export default __webpack_public_path__ + "static/media/Add User-rafiki.1360b4e0.svg";